export default [
  {
    path: '/storage-request',
    name: 'storage-request',
    component: () => import('@/views/pages/kompack/storage-request/StorageRequest.vue'),
    meta: {
      resource: 'StorageRequest',
      action: 'manage',
    },
  },
  {
    path: '/storage-request/:id',
    name: 'storage-request-detail',
    component: () => import('@/views/pages/kompack/storage-request/detail/StorageRequestDetail.vue'),
    meta: {
      resource: 'StorageRequest',
      action: 'manage',
      navActiveLink: 'storage-request',
    },
  },
]
